import React from 'react';
import { Link } from 'react-router';
// import sanitizeHTML from 'sanitize-html'; // use this or change to react-render-html
import slugify from 'slugify';
import { nanoid } from 'nanoid';
import axios from 'axios';
import {
  CalculateBroadCastYearOfEvent,
  CalculateMonthDayEvent,
  FormatDateString,
  isValidDateFormat,
  _formatDate,
  FormatDateTime,
  FormatDateTimeInESTTimeZone,
  FormatDateTimeUTC,
  GetMonthFirstLastDate,
  addDays,
} from './DateTimeHelper';
import { ACTIVATION_BUSINESS_UNIT } from 'src/constants/ActivationConstants';
import { parseEurPrice } from 'src/utils/csvHelper';
export { getCookies, removeCookies, setCookies } from './CookieHelper';
export { clearSession, getSessionProfile, getSessionToken, setSessionProfile, setSessionToken } from './SessionHelper';
export { generateCampaignLink, generateURL, isValidURL } from './UrlHelper';

/* 
  To slugify book title to - separated string to build book detail link for catalog site.
  Used from bookedit invalidatecache
*/
export const formatSlug = title => {
  if (title) {
    return slugify(title, {
      lower: true,
      strict: true,
      remove: /[*+~.()'"!:@]/g,
    });
  }
};

//Getting unique comma separated customcategory ids and name
export const getCommaSeparatedValue = (obj, parentPropertyName, childPropertyName) => {
  let data = new Set();

  obj[parentPropertyName] &&
    obj[parentPropertyName].forEach(item => {
      item.forEach(child => {
        data.add(child[childPropertyName]);
      });
    });
  return Array.from(data);
};

/* 
  At various tables, we display author name, this function will accept author firebrand id and author name and return <Link> to author's social data like http://local.peggy.openroadmedia.com/social-data?id=46410376&name=Arthur%20C.%20Clarke

  Currently it is used in TSD Report blastRecommendation result
*/
export const generateAuthorSocialDataLink = (authorFirebrandId, authorName) => {
  if (authorFirebrandId && authorName)
    return (
      <Link
        to={{ pathname: '/others/social-data', search: `?id=${authorFirebrandId}&name=${authorName}` }}
        target={'_blank'}
      >
        {authorName}
      </Link>
    );
};
// export const apppendFilters = (colsData, clear) => {
//   colsData.forEach(item => {
//     item.filter = customFilter({
//       onFilter: customFilterColumn,
//     });
//     item.filterRenderer = (onFilter, column) => (
//       <ColumnFilter type={item.type} clear={clear} onFilter={onFilter} column={column} />
//     );
//   });
//   return colsData;
// };
/* 
  Currently it is used in HaloResults, TwoFiftyKSaleTableColumns,ContentNlDealsSaleTableColumns, ViewServiceRequest
*/
export const generateBookDetailLink = (isbn, title) => {
  if (isbn && title)
    return (
      <Link to={{ pathname: `/book/${isbn}` }} target={'_blank'}>
        {title}
      </Link>
    );
};

/* 
  Currently it is used in ViewServiceRequest
*/
export const generateCampaignLinkNew = (campaignId, title) => {
  if (campaignId && title)
    return (
      <Link to={{ pathname: `/campaign/edit/${campaignId}` }} target={'_blank'}>
        {title}
      </Link>
    );
  else return '';
};

//To generate Unique Key for any given component
export const generateUniqueComponentKey = (size = 16) => {
  return nanoid(size);
  //crypto package was too expensive, to reduce bundle size replace it with uuid
  //return crypto.randomBytes(16).toString("hex");
};

/*
 * 15 - ORM - Murder & Mayhem NL
 * 18 - ORM - Archive NL
 * 20 - ORM - Portalist NL
 * 22 - ORM - The Lineup NL
 * 24 - ORM - The Reader NL
 * 36 - ORM - A Love So True NL
 *
 * 43 - ORM - A Love So True Content NL
 * 44 - ORM - Archive Content NL
 * 45 - ORM - Murder & Mayhem Content NL
 * 46 - ORM - Portalist Content NL
 * 47 - ORM - The Lineup Content NL
 */
export const isNewsLetterCampaign = value => {
  const nlCampaigns = new Set([15, 18, 20, 22, 24, 36, 43, 44, 45, 46, 47]);
  return nlCampaigns.has(Number(value));
};

/*
 * 37 - ORM - Early Bird Books Site Deals
 * 38 - ORM - A Love So True Site Deals
 * 39 - ORM - Archive Site Deals
 * 40 - ORM - Murder & Mayhem Site Deals
 * 41 - ORM - Portalist Site Deals
 * 42 - ORM - The Lineup Site Deals
 * 54 - ORM - Early Bird Books 250 Sale
 * 13 - ORM - Early Bird Books NL
 */
export const isSiteDealsCampaign = value => {
  const sdCampaigns = new Set([37, 38, 39, 40, 41, 42, 54, 13]);
  return sdCampaigns.has(Number(value));
};

/*
 * 25 - Nook Deals
 * 26 - iBooks Deals
 * 27 - Google Play Deals
 * 28 - Kobo Deals
 * 60 - Amazon - Deals
 */
export const isRetailPromotionCampaign = value => {
  const rtPCampaigns = new Set([25, 26, 27, 28, 60]);
  return rtPCampaigns.has(Number(value));
};

/**
 * title: title of the book
 * primaryisbn: isbn of the book
 * asin: asin of the book
 * googleId: google id of the book
 * appleId: apple id of the book
 * appleEan: apple ean of the book
 * retailerSiteLinks: links coming from DB, if any
 * amazon: amazon affiliate tag coming from sitesettings
 * apple: apple affiliate tag coming from sitesettings
 * barnes_nobles: b&n affiliate tag coming from sitesettings
 * kobo: kobo affiliate tag coming from sitesettings
 * takes retailer affiliate and returns a array of objects with retailer affiliates links
 */

// we moved this functionality into rest api
// export const generateAffiliateLinks = (book, affiliate) => {
//   const { amazon, apple, barnes_nobles, kobo } = affiliate;
//   const primaryisbn = book.primary_isbn ? book.primary_isbn : book.primaryisbn;
//   const googleId = book.google_id ? book.google_id : book.googleId;
//   const appleEan = book.apple_ean ? book.apple_ean : book.appleEan;
//   const appleId = book.apple_id ? book.apple_id : book.appleId;
//   const overdriveId = book.overdriveid ? book.overdriveid : book.overdriveId;
//   const retailerSiteLinks = book.retailer_site_links ? book.retailer_site_links : book.retailerSiteLinks;
//   const asin = book.asin;
//   const Title = book.title ? book.title : book.Title;
//   const affiliates = [];
//   // Amazon affiliate links
//   let amazon_url = "";
//   if (asin) {
//     amazon_url = `https://www.amazon.com/dp/${asin}`;
//   }
//   // E.L temp fix for compensating for marketing services that don't have ASIN's
//   if (!asin && retailerSiteLinks && retailerSiteLinks.length) {
//     const amazonLink = retailerSiteLinks.find(site => site.name === "Amazon");
//     if (amazonLink) amazon_url = amazonLink.url;
//   }

//   if (amazon && amazon_url) {
//     amazon_url += `?tag=${amazon}`;
//   }

//   if (amazon_url) {
//     affiliates.push({
//       name: "Amazon",
//       ref: "amazonLink",
//       url: amazon_url,
//     });
//   }

//   // Kobo and Barnes & Noble affiliate link
//   if (primaryisbn) {
//     let urlBarn = "";

//     // Barnes & Noble
//     if (barnes_nobles && primaryisbn) {
//       urlBarn = `http://www.anrdoezrs.net/links/${barnes_nobles}/type/dlg/https://www.barnesandnoble.com/w?ean=${primaryisbn}`;
//     }

//     affiliates.push({
//       name: "Barnes & Noble",
//       ref: "bnLink",
//       url: urlBarn,
//     });

//     // iTunes affiliate link
//     let apple_url = "";

//     // RT: Assign apple ean13 or primaryisbn
//     let title = "";
//     if (Title){
//       title = Title.toLowerCase();
//       title = title.split(' ');
//       title = title.join('-');
//       title = unescape(title);
//     }
//     if (appleId && title) {
//       apple_url = `https://books.apple.com/us/book/${title}/id${appleId}`;
//     } else if (appleEan) {
//       apple_url = `http://itunes.apple.com/us/book/isbn${appleEan}`;
//     } else {
//       apple_url = `http://itunes.apple.com/us/book/isbn${primaryisbn}`;
//     }

//     // RT: append affliate code if we have it
//     if (apple) {
//       apple_url += `?ct=${apple}&at=10lrBN`;
//     } else {
//       apple_url += "?at=10lrBN";
//     }

//     affiliates.push({
//       name: "Apple",
//       ref: "itunesLink",
//       url: apple_url,
//     });

//     // Google affiliate link
//     //if (googleId) {
//       affiliates.push({
//         name: "Google",
//         ref: "googleLink",
//         url: `https://play.google.com/store/books/details/?id=ISBN_${primaryisbn}&PAffiliateID=1101lHGm`, //E.L hardcoded affiliate id because it is the same regardless of site id's used
//       });
//     //}

//     if (kobo) {
//       affiliates.push({
//         name: "Kobo",
//         ref: "koboLink",
//         url: `https://click.linksynergy.com/deeplink?id=27lTva583xw&mid=37217&u1=${kobo}&murl=https://www.kobo.com/us/en/search?Query=${primaryisbn}`,
//       });
//     }

//     // Overdrive affiliate link
//     if (overdriveId) {
//       affiliates.push({
//         name: "Overdrive",
//         ref: "overdriveLink",
//         url: `https://www.overdrive.com/media/${overdriveId}/${title}`,
//       });
//     }

//     if (retailerSiteLinks && retailerSiteLinks.length > 0) {
//       const buyFromUs = retailerSiteLinks.find(link => link.name && link.name.toLowerCase() === "buy from us");
//       if(buyFromUs && buyFromUs.url) {
//         affiliates.push({
//           name: "Buy From US",
//           ref: "buyfromusLink",
//           url: buyFromUs.url
//         });
//       }
//     }

//     return affiliates;
//   }
// };

export const generateEmptyLinks = links => {
  const linkSet = new Set();
  // determining the links that are already present in the array
  for (let i = 0; i < links.length; i++) {
    switch (formatRetailerName(links[i].name)) {
      case `Amazon`:
        linkSet.add('Amazon');
        break;
      case `Apple`:
        linkSet.add('Apple');
        break;
      case `Apple Books`:
        linkSet.add('Apple');
        break;
      case `B&N`:
        linkSet.add('B&N');
        break;
      case `Barnes & Noble`:
        linkSet.add('B&N');
        break;
      case `Google`:
        linkSet.add('Google');
        break;
      case `Kobo`:
        linkSet.add('Kobo');
        break;
      case `Buy From Us`:
        linkSet.add('Buy From Us');
        break;
      default:
        linkSet.add(links[i].name);
        break;
    }
  }

  const pushLink = (links, link, shortName) => {
    links.push({
      name: link,
      ref: link.toLowerCase(),
      shortName,
      url: '',
    });
  };

  // pushing the links that are not in the array
  if (!linkSet.has('Amazon')) {
    pushLink(links, 'Amazon', 'amazon');
  }
  if (!linkSet.has('Apple')) {
    pushLink(links, 'Apple', 'apple');
  }
  if (!linkSet.has('B&N')) {
    pushLink(links, 'Barnes & Noble', 'barnesNoble');
  }
  if (!linkSet.has('Google')) {
    pushLink(links, 'Google', 'google');
  }
  if (!linkSet.has('Kobo')) {
    pushLink(links, 'Kobo', 'kobo');
  }
  if (!linkSet.has('Buy From US')) {
    pushLink(links, 'Buy From US', 'buyFromUs');
  }

  return links;
};

// use to format the name of retailer's buttons
export const formatRetailerName = retailer => {
  if (retailer) {
    switch (retailer) {
      case 'Amazon':
        return 'Amazon';
      case 'Apple':
        return 'Apple';
      case 'Apple Books':
        return 'Apple';
      case 'B&N':
        return 'B&N';
      case 'Barnes & Noble':
        return 'B&N';
      case 'Google':
        return 'Google';
      case 'Kobo':
        return 'Kobo';
      case 'Buy From US':
        return 'Buy From US';
      default:
        return retailer;
    }
  }
};

/**
 * links: Links to be rearranged
 * condition: where the function is called from -- based on certain page, we are ordering the links differently
 */
export const retailerReArrange = (links, condition) => {
  if (!links) return;
  for (let i = 0; i < links.length; i++) {
    switch (formatRetailerName(links[i].name)) {
      case 'Amazon':
        links[i].order = 1;
        break;
      case 'B&N':
        condition === 'bookedit' ? (links[i].order = 3) : (links[i].order = 2);
        break;
      case 'Apple':
        condition === 'bookedit' ? (links[i].order = 2) : (links[i].order = 3);
        break;
      case 'Google':
        links[i].order = 4;
        break;
      case 'Kobo':
        links[i].order = 5;
        break;
      case 'Overdrive':
        links[i].order = 6;
        break;
      case 'Buy From US':
        links[i].order = 7;
        break;
      default:
        links[i].order = 8;
    }
  }
  return links.sort((a, b) => {
    return a.order - b.order;
  });
};

//Shold receive books array which contains minimum ISBN field. It will append fetch googleId to incoming array and return same array to client
export const FetchGoogleIds = async books => {
  //Based on https://dev.to/tqbit/use-async-await-with-javascript-s-map-and-other-high-order-functions-25mn
  const FetchId = books.map(async book => {
    let url = `https://www.googleapis.com/books/v1/volumes?q=ISBN:${book.ISBN}&orderBy=newest&fields=items(id)&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
    let response = await axios.get(url);
    console.log('google response.data ', response.data);
    if (response && response.status === 200 && response.data && response.data.items && response.data.items.length > 0)
      book.Google_Id = response.data?.items[0]?.id;

    return book;
  });
  return await Promise.all(FetchId);
};

export const formatBookCoverImage = image => {
  if (!image) return null;
  let imagePath = `${process.env.REACT_APP_BOOK_COVER_S3_BASE_URL}/${image}`;
  return imagePath;
};

export const GetDefaultNotification = (startDate, endDate, notificationArr = []) => {
  let notificationOption = process.env.REACT_APP_NOTIFICATION_OPTION.split(',');
  const createNotification = (notificationArray, type) => {
    let date = startDate;
    if (type === 'end') {
      date = endDate;
    }
    if (notificationArray.length === 0) {
      return notificationOption.map(option => {
        option = parseInt(option);
        return {
          email: [],
          eventdate: CalculateMonthDayEvent(date, option),
          eventday: option,
          eventyear: CalculateBroadCastYearOfEvent(date, option),
          eventtype: type,
        };
      });
    } else {
      return notificationOption.map(option => {
        option = parseInt(option);
        let noti = notificationArray.find(n => n.eventday === option && n.eventtype === type);
        if (noti) return noti;
        else {
          return {
            email: [],
            eventdate: CalculateMonthDayEvent(date, option),
            eventday: option,
            eventyear: CalculateBroadCastYearOfEvent(date, option),
            eventtype: type,
          };
        }
      });
    }
  };
  let notification = [];

  let startDateNotification = createNotification(notificationArr, 'start');
  let endDateNotification = createNotification(notificationArr, 'end');
  notification.push(...startDateNotification);
  notification.push(...endDateNotification);
  return notification;
};

export const isValidSiteFormat = sites => {
  let contentSites = sites.trim();
  let sitesArray = contentSites.split(',');
  var arr1 = [
    'Early Bird Books',
    'The Lineup',
    'The Portalist',
    'Murder & Mayhem',
    'The Archive',
    'A Love So True',
    'All',
  ];
  var arr2 = [
    'Early Bird Books',
    'The Line Up',
    'The Portalist',
    'Murder & Mayhem',
    'Explore The Archive',
    'A Love So True',
    'All',
  ];
  let trimcontentSites = sitesArray.map(item => item.trim());
  for (let i = 0; i < trimcontentSites.length; i++) {
    if (!arr1.includes(trimcontentSites[i]) && !arr2.includes(trimcontentSites[i])) {
      return false;
    }
  }
  return true;
};

export const isbnFormat = isbns => {
  let isbnstrimmed = isbns?.trim();
  let isbnArray = isbnstrimmed?.split(',');
  let isbnArraytrimmed = isbnArray?.map(item => item.trim());
  return isbnArraytrimmed;
};

export const sitesFormat = msitesdata => {
  let sitestrimmed = msitesdata?.trim();
  let sitesArray = sitestrimmed?.split(',');
  let sitesArraytrimmed = sitesArray?.map(item => item.trim());
  let msites = sitesArraytrimmed ? [...sitesArraytrimmed] : [];
  if (msites.length > 0) {
    for (let i = 0; i < msites.length; i++) {
      var marr = ['The Lineup', 'The Archive'];
      if (msites[i] === marr[0]) {
        msites[i] = 'The Line Up';
      }
      if (msites[i] === marr[1]) {
        msites[i] = 'Explore The Archive';
      }
    }
  }
  return msites;
};

/////////////////////////VALIDATION FOR MILESTONE EVENTS//////////////////////////////////////
////////// Validate CSV header fields for milestone events///////////////////////////////////
export const validateEventsCSVHeaders = headerFields => {
  let errors = '';
  let columnsNotFound = [];
  let bad = false;
  let fields = ['Event Name', 'Type', 'Frequency', 'Start Date', 'End Date'];
  let element = headerFields.map(v => v.toLowerCase());
  for (let i = 0; i < fields.length; i++) {
    if (!element.includes(fields[i].toLowerCase())) {
      bad = true;
      columnsNotFound.push(fields[i]);
    }
  }
  if (bad) {
    errors = 'Invalid Csv : Column(s) not found (' + columnsNotFound.join(',') + ')';
  }
  return errors;
};

////////////////////////////VALIDATION OF CSV DATA/////////////////////////////////
export const validateEventsCSVData = csvData => {
  let errors = [],
    fieldError = [];
  let headerFields = [
    {
      name: 'Event Name',
      validate: (field, name) => {
        if (!field) return `${name} is required`;
      },
    },
    {
      name: 'Type',
      validate: (field, name) => {
        if (!field) return `${name} is required`;
      },
    },
    {
      name: 'Frequency',
      validate: (field, name) => {
        if (!field) {
          return `${name} is required`;
        }
      },
    },
    {
      name: 'Start Date',
      validate: (field, name) => {
        if (!field) {
          return `${name} is required`;
        }
        if (field && !isValidDateFormat(field, 'MM/DD/YYYY', true)) {
          return `Formatting Error ${field}: Check the formatting of ${name}`;
        }
      },
    },
    {
      name: 'End Date',
      validate: (field, name) => {
        if (!field) {
          return `${name} is required`;
        }
        if (field && !isValidDateFormat(field, 'MM/DD/YYYY', true)) {
          return `Formatting Error ${field}: Check the formatting of ${name}`;
        }
      },
    },
    {
      name: 'Content Site',
      validate: (field, name) => {
        if (!field) {
          return;
        }
        if (field && !isValidSiteFormat(field)) {
          return `Site Error ${field}: Check the formatting of ${name}`;
        }
      },
    },
    {
      name: 'Primary ISBN',
      validate: (field, name) => {
        if (!field) {
          return;
        }
      },
    },
    {
      name: 'Description',
      validate: (field, name) => {
        if (!field) {
          return;
        }
      },
    },
  ];

  for (var i = 0; i < csvData.length; i++) {
    let row = csvData[i];
    var count = 0;
    const fields = Object.keys(row);
    for (var j = 0; j < fields.length; j++) {
      let field = fields[j];
      if (row.hasOwnProperty(field)) {
        fieldError = headerFields[count].validate(row[field], field);
        if (fieldError) {
          errors.push({ error: fieldError, title: row['Event Name'] });
        }
        ++count;
      }
    }
  }
  return errors;
};

////////////////////////////FORMAT OF CSV DATA////////////////////////////////
export const formatEventsCSVData = data => {
  let formatedCSV = [];
  if (data.length) {
    for (var i = 0; i < data.length; i++) {
      let contentSitesdata = sitesFormat(data?.[i]?.['Content Site']?.trim());
      let books = isbnFormat(data[i]['Primary ISBN']);
      let sites = [];
      let bookdata = [];
      let rowData = {
        title:
          data[i]['event name'] ||
          data[i]['Event Name'] ||
          data[i]['Event name'] ||
          data[i]['event Name'] ||
          data[i]['EventName'] ||
          data[i]['eventname'],
        type: data[i]['type'] || data[i]['Type'],
        frequency: data[i]['frequency'] || data[i]['Frequency'],
        startdate: data[i]['start date'] || data[i]['Start Date'] || data[i]['start Date'] || data[i]['Start date'],
        enddate: data[i]['end date'] || data[i]['End Date'] || data[i]['end Date'] || data[i]['Start date'],
        description: data[i]['Description'] ? data[i]['Description'] : '',
      };
      //Insert Content Sites
      if (contentSitesdata && contentSitesdata.length > 0) {
        contentSitesdata.map(site => sites.push(site));
      } else {
        sites.push('ALL');
      }
      rowData.contentSite = sites;

      //get the book details
      //Insert books
      if (books && books.length >= 0) {
        for (let j = 0; j < books.length; j++) {
          let item = {};
          item.primary_isbn = books[j];
          bookdata.push(item);
        }
        rowData.books = bookdata;
      }
      formatedCSV.push(rowData);
    }
  }
  return formatedCSV;
};

export const validateEmailFormat = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validatePassword = password => {
  const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
  return re.test(password);
};

// Formats a duration stored in seconds as hhh:mm:ss (hours not capped at 2 digits, since audiobook
// durations can run past 99 hours for omnibus editions).
export const formatDuration = durationInSeconds => {
  // Number(...) coerces null/''/whitespace-only strings to 0, which would otherwise render a
  // missing duration as a fake "000:00:00" instead of leaving it blank.
  if (durationInSeconds === null || durationInSeconds === undefined || String(durationInSeconds).trim() === '') {
    return null;
  }

  const totalSeconds = Number(durationInSeconds);

  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
    return null;
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  return `${String(hours).padStart(3, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

//input arr : array of string
//output: array of object {value: "", label: ""}
export const getSelectOptions = arr => {
  if (arr?.length > 0) {
    return arr.map(value => ({ value: value, label: value }));
  } else {
    return [];
  }
};

export const getCurrentDate = () => {
  let today = new Date();
  today.setHours(0, 0, 0, 0);
  today = FormatDateString(today, 'YYYY/MM/DD');
  return today;
};

export const formatAudioContractRequiredField = obj => {
  return {
    ormContractDate: _formatDate(obj.ormContractDate, 'MM/dd/yyyy'),
    ormAudioExpiration: _formatDate(obj.ormAudioExpiration, 'MM/dd/yyyy'),
    ormAutoRenew: obj.ormAutoRenew,
    audioPublisherContractDate: _formatDate(obj.audioPublisherContractDate, 'MM/dd/yyyy'),
    audioPublisherExpiration: _formatDate(obj.audioPublisherExpiration, 'MM/dd/yyyy'),
    audioPublisherAutoRenew: obj.audioPublisherAutoRenew,
    physicalRoyalties: obj.physicalRoyalties ? `${obj.physicalRoyalties}%` : '',
    digitalRoyalties: obj.digitalRoyalties ? `${obj.digitalRoyalties}%` : '',
    ormAutoRenewTerm: obj.ormAutoRenewTerm,
    audioPublisherAutoRenewTerm: obj.audioPublisherAutoRenewTerm,
    paySchedule: obj.paySchedule ? obj.paySchedule?.join(',') : '',
    audioBookPubDate: _formatDate(obj.audioBookPubDate, 'MM/dd/yyyy') || '',
    audioPublisher: obj.audioPublisher,
    ormContractStatus: obj.ormContractStatus,
    audioPublisherContractStatus: obj.audioPublisherContractStatus,
    language: obj.language,
    advance: obj.advance || '',
    agent: obj.agent || '',
    comment: obj.comment || '',
  };
};

export const formatAudioContractDataForTable = data => {
  let formatData = [];
  if (data && data.length > 0) {
    formatData = data.map(value => {
      const book = value.Books && value.Books[0];
      const bookData = value.BookData && value.BookData[0];
      return {
        _id: value._id,
        id: value._id,
        ...formatAudioContractRequiredField(value),
        primaryIsbn: value.primaryIsbn,
        active: value.active,
        dlp: bookData?.US.dlp || '',
        title: book?.title,
        territorydesc: book?.territorydesc || '',
        authordisplayname: book?.authordisplayname || '',
        pub_date: _formatDate(book?.pub_date, 'MM/dd/yyyy'),
        bisacs: book?.bisacs || '',
        frontlist: book?.frontlist || '',
        imprint: book?.imprint || '',
      };
    });
  }
  return formatData;
};

// Format CSV data into service request schema modal
export const formatServiceRequestData = data => {
  if (!data || Object.keys(data).length === 0) return {};
  return {
    title: data.Title,
    primaryIsbn: data.primary_isbn,
    asin: data.asin,
    authors: data.Authors,
    dlp: data.DLP,
    saleDlp: data.SaleDLP,
    runDate: data.RunDate && FormatDateTime(data.RunDate).format('YYYY-MM-DD'),
    businessUnit: data.BusUnit,
    countries: data.Countries
      ? data.Countries.split(',')
          .map(country => country.trim())
          .filter(country => country)
      : [],
    serviceType: data['Service Type'],
    serviceStatus: 'Scheduled',
    transactionId: data.transactionId,
    transactionName: data.transactionName,
    trackingId: data.trackingId,
    url: data.Url,
    displayAdsType: data['Display Ads Type'],
    startDate: data['Start Date'] && FormatDateTime(data['Start Date']).format('YYYY-MM-DD'),
    endDate: data['End Date'] && FormatDateTime(data['End Date']).format('YYYY-MM-DD'),
    campaignName: data['Campaign Name']
      ? data['Campaign Name']
      : ACTIVATION_BUSINESS_UNIT.get(data.BusUnit)?.campaignName,
    active: true,
    pubDate: data.pubDate,
  };
};

export function debounce(fn, delay = 300) {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export const getValueForDropdown = (options, value) => {
  return options.find(option => option.value === value) || '';
};

// This function take a string text and update sqareBracket value using dynamicValues object
// text should be => "Filter date should be [[startdate]]"
// dynamicValues should be => {startdate: 04/04/2024}
export const updateDynamicTextValues = (text, dynamicValues) => {
  // Regular expression to match values within square brackets
  var regex = /\[\[([^[\]]*)\]\]/g;
  // Replace all matches with corresponding dynamic values
  var updatedTitle = text.replace(regex, function (match, key) {
    return dynamicValues[key] || match; // Use the dynamic value if available, otherwise keep the original match
  });

  return updatedTitle;
};

export const textColorStatus = str => {
  if (!str) return '';
  const normalizedStatus = Array.isArray(str) ? str.join(', ') : String(str);
  const status = normalizedStatus.toUpperCase();
  if (status?.includes('FAIL') || status === 'CANCELED') {
    return 'error';
  } else if (status.includes('QUEUE') || status === 'PENDING' || status === 'NO PRICE CRAWLED') {
    return 'warning';
  } else if (status === 'SCHEDULED' || status?.includes('PARTIAL SUCCESS')) {
    return 'primary';
  } else if (status.includes('DONE') || status.includes('SUCCESS') || status === 'APPROVED' || status === 'PASSED') {
    return 'success';
  } else if (status.includes('REJECT')) {
    return 'secondary';
  } else if (status.includes('SKIP') || status.includes('DELETE')) {
    return 'textSecondary';
  }
};

/**
 * Colour for the campaign's Price Log Status. Once Eloquence is done ('Success') the colour comes from
 * the CampOps retailer check: green when every title passed, yellow when some did, red when none did,
 * and black while there is no retailer result yet. Every other status keeps `textColorStatus`.
 */
export const pricelogStatusColor = (pricelogStatus, retailerStatus) => {
  if (pricelogStatus !== 'Success') return textColorStatus(pricelogStatus);
  if (retailerStatus === 'Success') return 'success';
  if (retailerStatus === 'Partial Success') return 'warning';
  if (retailerStatus === 'Failed') return 'error';
  return 'common.black';
};

export const validateEmail = email => {
  let res = email.split(',');
  res = res.map(v => v.trim());
  let validEmail = [];
  for (let i = 0; i < res.length; i++) {
    let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    validEmail.push(re.test(res[i]));
  }
  if (!validEmail.some(e => e === false)) {
    return true;
  }
};

/**
 * Prevents changes to the input value and container scrolling when the mouse wheel is used.
 *
 * This function is intended to be used as an event handler for the 'wheel' event on number input elements.
 * It ensures that the input value does not change and the container does not scroll when the mouse wheel
 * is used over the input.
 *
 * @param {Event} e - The wheel event object.
 */
export const preventOnWheelChange = e => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the container scrolling
  e.stopPropagation();
};

/**
 * Utility function to update a nested property within an object.
 * @param {Object} obj - The object to update.
 * @param {String} path - The dot-separated path of the property to update.
 * @param {*} value - The value to set at the specified property path.
 * @returns {Object} - A new object with the updated property.
 */
export const updateNestedState = (obj, path, value) => {
  // Split the path into keys
  const keys = path.split('.');

  // Make a shallow copy of the object to avoid mutating the original object
  let newObj = { ...obj };
  let current = newObj;

  // Iterate through the keys to traverse the nested structure
  for (let i = 0; i < keys.length - 1; i++) {
    // If the key does not exist, create an empty object at that key
    if (!current[keys[i]]) {
      current[keys[i]] = {};
    } else {
      // Make a shallow copy to avoid mutating the original nested object
      current[keys[i]] = { ...current[keys[i]] };
    }
    current = current[keys[i]];
  }

  // Set the value at the specified property path
  current[keys[keys.length - 1]] = value;

  return newObj;
};

// Function to determine the final territory list based on title information
export const fetchFinalIncludeTerritory = (countryList, titleInfo) => {
  let finalTerritory = countryList;

  // Filter for exclusive territories if they exist in the title information
  if (titleInfo.exclusiveterritory) {
    finalTerritory = finalTerritory.filter(country => titleInfo.exclusiveterritory.includes(country));
  }

  // Exclude non-exclusive territories if they exist in the title information
  if (titleInfo.nonexclusiveterritory) {
    finalTerritory = finalTerritory.filter(country => titleInfo.nonexclusiveterritory.includes(country));
  }

  // Exclude "not for sale" territories if they exist in the title information
  if (titleInfo.notforsaleterritory) {
    finalTerritory = finalTerritory.filter(country => !titleInfo.notforsaleterritory.includes(country));
  }

  return finalTerritory;
};

/**
 * Checks if the user has a specific permission.
 *
 * This function examines the user's role and its associated permissions
 * to determine if the user has the specified permission.
 *
 * @param {Object} user - The user object containing user details and roles.
 * @param {string} permission - The name of the permission to check for.
 * @returns {boolean} - Returns true if the user has the specified permission, otherwise false.
 */
export const hasPermission = (userRole, permission) => {
  if (!userRole) return false;
  return userRole?.rolepermission?.some(item => item.name === permission) || false;
};

/**
 * This function takes raw campaign submission data in JSON format and processes it to return
 * a map where the key is the campaign type and the value is a fully formatted list of promoted book titles
 * with relevant information such as author, ASIN, start and end dates, promo price, and applicable countries for the promotion.
 *
 * The input data is expected to have column names (or keys) like 'Title', 'Author', 'Submitted Isbn',
 * 'Mailing Date', 'Approved Category', and country-specific promo prices like 'AU Deal Price', 'US Deal Price', etc.
 * The function normalizes the keys to lowercase, cleans up promo prices, and groups books by the countries
 * in which the promotion is active, along with the corresponding price.
 *
 * @param {Array} data - The raw submission data in JSON format. Each entry represents a book and its promo details.
 * @returns {Object} - A map where the key is the campaign type and the value is an array of fully formatted promoted titles.
 */
export const parseBookbubSubmissionData = data => {
  // Process each row of data to extract and normalize relevant fields
  const formattedEntries = data.flatMap(rowData => {
    // Convert all keys in rowData to lowercase for case-insensitive access
    const normalizedRowData = Object.keys(rowData).reduce((acc, key) => {
      acc[key.toLowerCase()] = rowData[key];
      return acc;
    }, {});

    // Define promo prices for each country (AU, US, GB, CA) and associate the price with each country
    const promoCountries = [
      { country: 'AU', price: normalizedRowData['au deal price'] },
      { country: 'US', price: normalizedRowData['us deal price'] },
      { country: 'GB', price: normalizedRowData['uk deal price'] },
      { country: 'CA', price: normalizedRowData['ca deal price'] },
    ];

    const promoPriceMap = {};

    // Group countries by promo price and clean up prices (remove non-numeric characters)
    promoCountries.forEach(promo => {
      // Remove non-numeric characters from the price (if any) and ensure the price is valid
      const price = typeof promo.price === 'string' ? promo.price.replace(/[^\d.]/g, '') : promo.price;

      // If the price is valid, group the countries by that promo price
      if (price && !isNaN(price)) {
        if (!promoPriceMap[price]) {
          promoPriceMap[price] = [];
        }
        promoPriceMap[price].push(promo.country);
      }
    });

    // Create an array of formatted entries, one for each promo price group
    return Object.keys(promoPriceMap).map(price => ({
      title: normalizedRowData['title'],
      author: normalizedRowData['author'],
      ASIN: normalizedRowData['submitted isbn'], // Use submitted ISBN as the ASIN
      startDate: FormatDateString(normalizedRowData['mailing date'], 'MM/DD/YYYY'),
      endDate: FormatDateString(normalizedRowData['mailing date'], 'MM/DD/YYYY'), // Assume end date is same as start date
      notes1: normalizedRowData['approved category'], // Additional notes (approved category)
      promoPrice: price, // Store the cleaned promo price
      countries: promoPriceMap[price], // Store the countries associated with this price
    }));
  });

  // Flatten the array of arrays and further format the entries for final output
  const promotedTitles = formattedEntries.flat().map(entry => {
    const promoCountries = entry.countries; // Extract the countries where the promo is active
    const promoPrice = entry.promoPrice; // Extract the promo price for the book

    // Return the fully formatted title object with all the required fields
    return {
      authors: entry.author, // Book author(s)
      bookbubcategory: entry.notes1, // Approved category for Bookbub
      category: entry.notes1, // Same category field as bookbubcategory
      country: promoCountries, // Countries where the promo is available
      startdate: entry.startDate, // Promo start date
      enddate: entry.endDate, // Promo end date (assumed to be the same as start date)
      kindle_deals_type: '', // Placeholder for Kindle deals type (can be updated later)
      notes: '', // Placeholder for additional notes (can be updated later)
      asin: entry.ASIN, // ASIN or ISBN of the book
      promo_price: parseFloat(promoPrice), // Convert the promo price from string to float
      title: entry.title, // Book title
      publisher: '', // Placeholder for publisher (can be updated later)
    };
  });

  // Return the final structure as a map where the key is the campaign type (3 for Bookbub)
  return {
    3: promotedTitles.flat(), // Use 3 as the campaign type for Bookbub feature deals
  };
};

/**
 * This function takes raw campaign submission data for Amazon Kindle promotions and processes it
 * to return a map where the key is the campaign type (e.g., KDD, DOTD) and the value is an array
 * of promoted titles with details such as title, author, ASIN, promo price, start and end dates,
 * and applicable countries for each campaign.
 *
 * The input data is expected to have fields like 'TITLE', 'AUTHOR', 'KINDLE ASIN', 'DEAL PRICE VLOOKUP',
 * 'DATE', and 'DEAL CATEGORY'. The function normalizes the author name format, processes the campaign
 * dates based on the deal category, and groups the books into different campaign types (e.g., KDD, Goldbox).
 *
 * Campaign types are mapped to specific values:
 * - KDD: Kindle Daily Deal (type 5)
 * - DOTD: Amazon Goldbox Deal of the Day (type 1)
 * - KBD: Kindle Big Deal (type 7)
 * - Monthly Deal: Kindle Monthly Deal (type 6)
 *
 * The function cleans up and formats the relevant data, and groups the books by campaign type, returning
 * the final map.
 *
 * @param {Array} data - The raw submission data for Amazon promotions in JSON format.
 * @returns {Object} - A map where the key is the campaign type, and the value is an array of promoted titles.
 */
export const parseAmazonDeals_US_SubmissionData = data => {
  const campaignTypeMap = {
    KDD: { type: 5, name: 'Amazon - KDD' },
    DOTD: { type: 56, name: 'Amazon - Goldbox' },
    KBD: { type: 7, name: 'Amazon - KBD' },
    'Monthly Deal': { type: 6, name: 'Amazon - KMD' },
  };

  // Function to convert "Last name, First name" to "First name Last name"
  const formatAuthorName = author => {
    if (!author.includes(',')) return author; // If there's no comma, return the author as is
    const [lastName, firstName] = author.split(',').map(name => name.trim());
    return `${firstName} ${lastName}`.trim(); // Return "First name Last name"
  };

  // Convert object keys to lower case for case-insensitive lookup
  const normalizeKeys = item => {
    const normalized = {};
    Object.keys(item).forEach(key => {
      normalized[key.toLowerCase()] = item[key];
    });
    return normalized;
  };

  // Create a map where the key will be the campaign type and the value will be the promoted titles
  const campaignMap = {};

  data.forEach(item => {
    try {
      // Normalize the keys of the item for case-insensitive access
      const normalizedItem = normalizeKeys(item);

      // Get campaign type from deal category (case insensitive)
      const campaignType = campaignTypeMap[normalizedItem['deal category']];

      if (!campaignType) {
        console.log(`Unknown campaign type: ${normalizedItem['deal category']}`);
        return; // Skip if campaign type is unknown
      }

      let startDate = new Date(normalizedItem['date']);
      if (isNaN(startDate.getTime())) {
        console.log(`Invalid date format: ${normalizedItem['date']}`);
        return; // Skip if the date is invalid
      }
      startDate = startDate.toISOString();

      let endDate;
      if (campaignType.name === 'Amazon - KBD') {
        endDate = addDays(normalizedItem['date'], 6); // KBD end date is start date + 6 days
      } else if (campaignType.name === 'Amazon - KMD') {
        endDate = GetMonthFirstLastDate(normalizedItem['date'], 'last'); // KMD end date is last day of the month
      } else {
        endDate = startDate; // For KDD and Goldbox, start date and end date are the same
      }

      const promotedTitle = {
        title: normalizedItem['title'],
        country: ['US', 'CA'], // Always US, CA
        promo_price: normalizedItem['deal price vlookup'],
        asin: normalizedItem['kindle asin'] || normalizedItem['asin'],
        notes: '',
        authors: formatAuthorName(normalizedItem['author'] || ''), // Convert author name if available
        category: '',
        publisher: '',
        bookbubcategory: '',
        kindle_deals_type: campaignType.name,
        startdate: FormatDateString(startDate, 'MM/DD/YYYY'),
        enddate: FormatDateString(endDate, 'MM/DD/YYYY'),
        retailers: ['Amazon'],
        campaignName: normalizedItem['deal team notes'] || '',
      };

      // Check if the campaign type already exists in the map
      if (!campaignMap[campaignType.type]) {
        campaignMap[campaignType.type] = []; // Initialize an empty array if not present
      }

      // Add the promoted title to the corresponding campaign type
      campaignMap[campaignType.type].push(promotedTitle);
    } catch (error) {
      console.error('Error processing item:', item, error);
    }
  });

  return campaignMap;
};

/**
 * Parses Amazon UK Deals submission data and organizes books into campaign maps.
 *
 * This function:
 *  - Normalizes the incoming keys to lowercase (to handle inconsistent column casing).
 *  - Reads book deal information (ASIN, title, author, deal type, start & end dates).
 *  - Determines the campaign type based on rules:
 *      • If the deal runs for a single day → it’s either KDD (Kindle Daily Deal) or Goldbox.
 *      • If the deal spans the entire calendar month → it’s KMD (Kindle Monthly Deal).
 *      • Otherwise → it’s KBD (Kindle Book Deal).
 *  - Creates a mapping (campaignMap) where each campaign type groups its promoted titles.
 *
 * Campaign types supported:
 *  - KDD → Amazon - KDD
 *  - Goldbox → Amazon - Goldbox
 *  - KMD → Amazon - KMD
 *  - KBD → Amazon - KBD
 *
 * @param {Array<Object>} data - The raw submission data (rows from spreadsheet or upload).
 * @returns {Object} campaignMap - An object where keys are campaign type IDs and values are arrays of promoted titles.
 *
 */
export const parseAmazonDeals_UK_SubmissionData = data => {
  const normalizeKeys = obj => {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key.toLowerCase()] = obj[key];
      return acc;
    }, {});
  };

  // Campaign type constants
  const CAMPAIGN_TYPES = {
    KDD: { type: 5, name: 'Amazon - KDD' },
    Goldbox: { type: 56, name: 'Amazon - Goldbox' },
    KMD: { type: 6, name: 'Amazon - KMD' },
    KBD: { type: 7, name: 'Amazon - KBD' },
  };

  const campaignMap = {};

  // Helper to compare only yyyy-mm-dd (ignoring time)
  const isSameDay = (d1, d2) => d1.isSame(d2, 'day');

  data.forEach(item => {
    try {
      const normalizedItem = normalizeKeys(item);

      const asin = normalizedItem['asin'];
      const eIsbn = normalizedItem['e-isbn'];
      const title = normalizedItem['title'];
      const author = normalizedItem['author'];
      const dealType = normalizedItem['deal type'];
      const startDate = normalizedItem['start date'];
      const endDate = normalizedItem['end date'];

      if (!asin || !title || !startDate || !endDate) {
        console.log('Missing required fields (ASIN, TITLE, DATES)');
        return;
      }

      const start = FormatDateTimeUTC(startDate, 'YYYY-MM-DD');
      const end = FormatDateTimeUTC(endDate, 'YYYY-MM-DD');

      let campaignType = null;

      if (isSameDay(start, end)) {
        if (
          dealType &&
          (dealType.toLowerCase().includes('kdd') || dealType.toLowerCase().includes('kindle daily deals'))
        ) {
          campaignType = CAMPAIGN_TYPES.KDD;
        } else if (
          dealType &&
          (dealType.toLowerCase().includes('goldbox') ||
            dealType.toLowerCase().includes('fiction') ||
            dealType.toLowerCase().includes('non-fiction'))
        ) {
          campaignType = CAMPAIGN_TYPES.Goldbox;
        }
      } else {
        const firstDay = start.startOf('month');
        const lastDay = start.endOf('month');

        if (isSameDay(start, firstDay) && isSameDay(end, lastDay)) {
          campaignType = CAMPAIGN_TYPES.KMD;
        } else {
          campaignType = CAMPAIGN_TYPES.KBD;
        }
      }

      if (!campaignType) {
        console.log(`Unknown campaign type: ${dealType}`);
        return;
      }

      const formattedStartDate = FormatDateString(start.toDate(), 'MM/DD/YYYY');
      const formattedEndDate = FormatDateString(end.toDate(), 'MM/DD/YYYY');

      const promotedTitle = {
        title,
        country: ['GB', 'EU', 'IN'],
        promo_price: 0,
        asin,
        primary_isbn: eIsbn,
        notes: '',
        authors: author || '',
        category: '',
        bookbubcategory: '',
        kindle_deals_type: campaignType.name,
        startdate: formattedStartDate,
        enddate: formattedEndDate,
        retailers: ['Amazon'],
      };

      if (!campaignMap[campaignType.type]) {
        campaignMap[campaignType.type] = [];
      }

      campaignMap[campaignType.type].push(promotedTitle);
    } catch (error) {
      console.error('Error processing item:', item, error);
    }
  });

  return campaignMap;
};

// Parses the International KMD approved file (Sheet1).
// Columns: asin, title_name, author_name, "Deal Price"
// All entries are KMD (type 6); countries default to standard INTL markets.
export const parseAmazonDeals_Intl_ApprovedData = data => {
  const KMD_TYPE = 6;
  const INTL_COUNTRIES = ['FR', 'DE', 'IT', 'NL', 'ES'];

  const formatAuthorName = author => {
    if (!author || !String(author).includes(',')) return String(author || '').trim();
    const [lastName, firstName] = String(author)
      .split(',')
      .map(n => n.trim());
    return `${firstName} ${lastName}`.trim();
  };

  const normalizeKeys = obj =>
    Object.keys(obj).reduce((acc, key) => {
      acc[key.toLowerCase().trim()] = obj[key];
      return acc;
    }, {});

  const campaignMap = {};

  data.forEach(item => {
    try {
      const n = normalizeKeys(item);

      const asin = n['asin'] ? String(n['asin']).trim() : '';
      const titleKey = Object.keys(n).find(k => k.includes('title'));
      const title = titleKey ? String(n[titleKey]).trim() : '';
      if (!asin || !title) return;

      const authorKey = Object.keys(n).find(k => k.includes('author'));
      const author = authorKey ? String(n[authorKey]).trim() : '';
      const dealPriceKey = Object.keys(n).find(k => k.includes('deal price'));
      const rawDealPrice = dealPriceKey ? n[dealPriceKey] : '';
      const promo_price_eur = parseEurPrice(rawDealPrice);

      const promotedTitle = {
        title,
        country: INTL_COUNTRIES,
        promo_price_eur,
        promo_price: '',
        asin,
        notes: '',
        authors: formatAuthorName(author),
        category: '',
        publisher: '',
        bookbubcategory: '',
        kindle_deals_type: 'Amazon - KMD',
        retailers: ['Amazon'],
      };

      if (!campaignMap[KMD_TYPE]) campaignMap[KMD_TYPE] = [];
      campaignMap[KMD_TYPE].push(promotedTitle);
    } catch (error) {
      console.error('Error processing INTL approved item:', item, error);
    }
  });

  return campaignMap;
};

export const formattedMessageForPricelog = data => {
  const {
    status,
    startdate,
    sentToFirebrandDate,
    updatedOnFirebrandDate,
    isStatusUpdatedByCron,
    useMasterPriceGrid,
    priceChangeType,
  } = data || {};

  let message = '';
  if (status?.toLowerCase() === 'scheduled') {
    let startDate = new Date();
    if (priceChangeType === 'dlp') {
      startDate = FormatDateTimeUTC(startdate).subtract(process.env.REACT_APP_DLP_CHANGE_RUN_BEFORE_DAYS, 'day');
    } else if (priceChangeType === 'manual') {
      startDate = FormatDateTimeUTC(startdate).subtract(process.env.REACT_APP_MANUAL_CHANGE_RUN_BEFORE_DAYS, 'day');
    } else {
      startDate = FormatDateTimeUTC(startdate).subtract(process.env.REACT_APP_PRICELOG_RUN_BEFORE_DAYS, 'day');
    }
    const currentDate = FormatDateTime();

    // Get current time in EST
    const currentEST = FormatDateTime().tz('America/New_York');
    const isAfter6PM = currentEST.hour() >= 18;

    // Check if the date is today or past
    if (startDate.isSame(currentDate, 'day') || startDate.isBefore(currentDate)) {
      // Check if time is after 6 PM in EST
      if (isAfter6PM) {
        message = 'Scheduled for pickup Tomorrow';
      }
      message = 'Scheduled for pickup Today';
    } else {
      // Otherwise, return the date in day format (e.g., 21)
      message = `Scheduled to pick up on ${startDate.format('MM/DD/YYYY')}`;
    }
  } else if (status?.toLowerCase() === 'queue' && sentToFirebrandDate) {
    const finalDate = FormatDateTimeInESTTimeZone(sentToFirebrandDate);
    message = `Queue at firebrand on ${finalDate}`;
  } else if (status?.toLowerCase() === 'done' && updatedOnFirebrandDate) {
    const finalDate = FormatDateTimeInESTTimeZone(updatedOnFirebrandDate);
    message = `Title successfully updated on ${finalDate}`;
  } else if (status?.toLowerCase() === 'done' && isStatusUpdatedByCron) {
    message = 'The status is automatically updated by an internal job.';
  }
  if (useMasterPriceGrid === false) {
    message += `\n Master Pricing Grid will not be used.`;
  }
  return message;
};

/**
 * Validates a comma-separated list of email addresses.
 *
 * This function performs the following checks:
 * 1. Ensures the input is not empty.
 * 2. Verifies that at least two email addresses are provided.
 * 3. Detects and reports duplicate email addresses.
 * 4. Validates each email address against the standard format.
 *
 * @param {string} input - A string containing comma-separated email addresses.
 * @returns {string|false} - An error message if validation fails, or `false` if validation succeeds.
 */
export const validateEmails = input => {
  if (!input) {
    return 'Field is Required!';
  }

  const emails = input.split(',').map(email => email?.trim()?.toLowerCase());

  // Check minimum email count
  if (emails.length < 2) {
    return 'Please enter at least two valid email addresses, separated by commas.';
  }

  // Check for duplicates
  const uniqueEmails = new Set();
  const duplicates = emails.filter(email => {
    if (uniqueEmails.has(email)) return true; // Duplicate found
    uniqueEmails.add(email);
    return false;
  });

  if (duplicates.length > 0) {
    return 'Duplicate email address found: ' + duplicates.join(', ');
  }

  // Check for invalid formats
  for (const email of emails) {
    if (!validateEmailFormat(email)) {
      return `${email} is not a valid email address. Please enter a valid email address.`;
    }
  }

  return false; // No errors
};

/**
 * Returns a unique list of child campaign types.
 *
 * - If an item has childGroups, use them.
 * - Otherwise, use the item itself.
 * - Removes duplicates based on the value field.
 *
 * @param {Array} value - List of campaign items with or without childGroups.
 * @returns {Array} Unique list of { value, label } objects.
 */

export const getChildCampaignTypes = value => {
  return [
    ...new Map(
      value
        .flatMap(item =>
          item.childGroups && item.childGroups.length > 0
            ? item.childGroups.map(el => ({ value: el.value, label: el.text }))
            : [{ value: item.value, label: item.label }]
        )
        .map(item => [item.value, item]) // Create a map with unique values
    ).values(), // Convert back to an array
  ];
};

/**
 * Generates a random alphanumeric string of a given length.
 *
 * @param {number} length - The length of the random string to generate (default: 8).
 * @returns {string} A randomly generated string containing uppercase, lowercase, and digits.
 *
 * Example:
 * generateRandomString(6); // "aZ1bX9"
 */
export const generateRandomString = (length = 8) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};

/**
 * Builds an HTML table string from provided data.
 *
 * @param {Object} config - Configuration object for the table.
 * @param {string} [config.title=''] - Optional title displayed above the table.
 * @param {Array<{label: string, field: string}>} [config.headers=[]] - Table headers.
 *        Each header is an object with:
 *          - label: Column name to display.
 *          - field: Property name in each row object.
 * @param {Array<Object>} [config.rows=[]] - Array of row objects representing table data.
 * @param {Object} [config.linkFields={}] - Optional mapping of fieldName → (row) => url.
 *        If provided, the value for that field will be wrapped in an <a> tag.
 * @param {Object} [config.formatters={}] - Optional mapping of fieldName → (value, row) => formattedValue.
 *        If provided, formats the value before rendering it in the table.
 *
 * @returns {string} - A complete HTML string representing the table.
 *
 */
export const buildHtmlTable = ({
  title = '',
  headers = [],
  rows = [],
  linkFields = {}, // { fieldName: (row) => url }
  formatters = {}, // { fieldName: (value, row) => formattedValue }
}) => {
  if (!rows.length) {
    return '';
  }

  // Escape HTML for plain text columns
  const escapeHtml = str =>
    String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  return `
    ${title ? `<p><strong>${title}</strong></p>` : ''}
    <table border="1" cellpadding="8" cellspacing="0" 
           style="border-collapse: collapse; width: 100%; margin-bottom: 24px;">
      <thead>
        <tr style="background-color: #e4e4e4; font-weight: bold;">
          ${headers.map(h => `<th>${h.label}</th>`).join('')}
        </tr>
      </thead>
      <tbody>
        ${rows
          .map(row => {
            return `
              <tr>
                ${headers
                  .map(h => {
                    let value = row[h.field] ?? '';

                    // Apply formatter if provided
                    if (formatters[h.field]) {
                      value = formatters[h.field](value, row);
                    }

                    // Ensure message column is plain text
                    if (h.field === 'message') {
                      value = escapeHtml(value);
                    }

                    // Apply link if provided (skip for message column)
                    if (linkFields[h.field]) {
                      const url = linkFields[h.field](row);
                      value = `<a href="${url}" target="_blank">${value}</a>`;
                    }

                    // Always return the value in a table cell
                    return `<td style="word-wrap: break-word;">${value}</td>`;
                  })
                  .join('')}
              </tr>
            `;
          })
          .join('')}
      </tbody>
    </table>
  `;
};

export const getBusinessArea = (title = {}, campaignStartDate) => {
  if (!title) return 'NA';

  const ms = title.marketingservices;
  const osd = title.onsaledate;
  const pub = title.publisher;

  // Parse campaignYear
  const campaignDate = new Date(campaignStartDate);
  const campaignYear = !isNaN(campaignDate) ? campaignDate.getUTCFullYear() : null;

  // Parse onSaleYear (either date string or direct year number)
  let onSaleYear = null;
  if (osd) {
    const d = new Date(osd);
    if (!isNaN(d)) {
      onSaleYear = d.getUTCFullYear();
    } else {
      const y = parseInt(osd, 10);
      if (!isNaN(y)) onSaleYear = y;
    }
  }

  if (!campaignYear || !onSaleYear || !pub) return 'NA';

  const back = onSaleYear <= campaignYear - 2;
  const prior = onSaleYear === campaignYear - 1;
  const front = onSaleYear >= campaignYear;

  const pubLc = pub.trim().toLowerCase();
  const isBloodhound = pubLc.includes('bloodhound');
  const isIgnition = !!(ms && String(ms).trim().toLowerCase().startsWith('y'));

  if (isBloodhound) {
    if (back) return 'Bloodhound Backlist';
    if (prior) return 'Bloodhound Prior Year';
    if (front) return 'Bloodhound Frontlist';
  } else if (isIgnition) {
    if (back) return 'Ignition Backlist';
    if (prior) return 'Ignition Prior Year';
    if (front) return 'Ignition Frontlist';
  } else {
    if (back) return 'Publishing Backlist';
    if (prior) return 'Publishing Prior Year';
    if (front) return 'Publishing Frontlist';
  }

  return 'NA';
};

/**
 * Recomputes business areas for all titles in a campaign
 * and rebuilds the businessareasummary.
 *
 * @param {Object} campaign - The campaign object
 * @param {string|Date} startdate - The campaign start date
 * @returns {Object} Updated campaign object with titles + summary
 */
export const recomputeBusinessAreas = (campaign, startdate) => {
  if (!campaign || !Array.isArray(campaign.promotedtitles)) return campaign;

  const summary = { titleCount: 0 };

  const updatedTitles = campaign.promotedtitles.map(title => {
    const businessarea = getBusinessArea(title, startdate);
    summary[businessarea] = (summary[businessarea] || 0) + 1;
    summary.titleCount++;
    return { ...title, businessarea };
  });

  return {
    ...campaign,
    promotedtitles: updatedTitles,
    businessareasummary: summary,
  };
};

// this function is used to check if filter value is valid
export const checkIsnotEmpty = value => {
  if (value) {
    // if value is not "", null, undefined then true
    if (Array.isArray(value) && value.length === 0) {
      // check for empty array
      return false;
    } else if (typeof value === 'object' && Object.keys(value).length === 0) {
      // check for empty object
      return false;
    } else {
      return true;
    }
  }
  return false;
};

/**
 * Builds step-wise status data for the Stepper
 * Steps: FITHub → Eloquence → Retailers
 */
export const buildStepStatuses = row => {
  const steps = [];

  if (row.status === 'scheduled') {
    return steps;
  }

  // ---- Step 1: FITHub ----
  if (row.status === 'failed') {
    steps.push({ status: 'failed' });
    return steps;
  }

  if (row.status === 'queue' || row.status === 'rejected') {
    steps.push({ status: row.status, updatedAt: row.sentToFirebrandDate });
    return steps;
  }

  // status === 'done'
  steps.push({ status: 'done', updatedAt: row.updatedOnFirebrandDate });

  // ---- Step 2: Eloquence ----
  if (row.eloquenceStatus === 'failed') {
    steps.push({ status: 'failed', updatedAt: row.updatedOnEloquenceDate });
    return steps;
  }

  if (row.eloquenceStatus === 'done') {
    steps.push({ status: 'done', updatedAt: row.updatedOnEloquenceDate });
  } else {
    steps.push({ status: 'queue', updatedAt: row.updatedOnFirebrandDate });
    return steps;
  }

  // ---- Step 3: Retailers ----
  if (!row.priceCheckCampops || row.priceCheckCampops.length === 0) {
    steps.push({ status: 'queue', updatedAt: row.updatedOnFirebrandDate });
    return steps;
  }

  const allDone = row.priceCheckCampops.every(item => item.status === 'passed');
  const allFailed = row.priceCheckCampops.every(item => item.status === 'failed');
  const updatedAt = row.priceCheckCampops[0]?.createdAt;

  if (allDone) {
    steps.push({ status: 'done', updatedAt });
  } else if (allFailed) {
    steps.push({ status: 'failed', updatedAt });
  } else {
    steps.push({ status: 'partial success', updatedAt });
  }

  return steps;
};

export const buildStats = (data = [], statusKey) => {
  if (!data.length) return {};

  const total = data.length;

  const counts = data.reduce((acc, item) => {
    const status = item?.[statusKey];
    if (!status) return acc;
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(counts).reduce((acc, [status, count]) => {
    acc[status] = {
      count,
      percent: Number(((count / total) * 100).toFixed(2)),
    };
    return acc;
  }, {});
};

export const buildRetailerStats = (data = []) => {
  if (!data.length) return {};

  const eloquenceStatusDone = data.filter(item => item.eloquenceStatus === 'done');
  if (eloquenceStatusDone.length === 0) return {};
  const total = eloquenceStatusDone.length;

  const counts = eloquenceStatusDone.reduce((acc, item) => {
    const retailerStatuses = item?.priceCheckCampops || item?.priceCheckCampopsParent || [];
    const hasDone = retailerStatuses.every(rs => rs.status === 'passed');
    const hasFailed = retailerStatuses.every(rs => rs.status === 'failed');
    let status = 'queue';
    if (retailerStatuses.length === 0) {
      status = 'queue';
    } else if (hasDone) {
      status = 'done';
    } else if (hasFailed) {
      status = 'failed';
    } else if (retailerStatuses.some(rs => rs.status === 'passed')) {
      status = 'partial_success';
    }

    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(counts).reduce((acc, [status, count]) => {
    acc[status] = {
      count,
      percent: Number(((count / total) * 100).toFixed(2)),
    };
    return acc;
  }, {});
};

export const parseRangeValues = value => {
  if (value === null || value === undefined) return null;

  const rawValue = String(value).trim();
  if (!rawValue) return null;

  if (rawValue.includes('to')) {
    const [startValue, endValue] = rawValue.split(/to/i).map(item => Number(item.trim()));
    if (!Number.isNaN(startValue) && !Number.isNaN(endValue)) {
      return [startValue, endValue].sort((a, b) => a - b);
    }
  }

  if (/^\d+(\.\d+)?\s*-\s*\d+(\.\d+)?$/.test(rawValue)) {
    const [startValue, endValue] = rawValue.split('-').map(item => Number(item.trim()));
    if (!Number.isNaN(startValue) && !Number.isNaN(endValue)) {
      return [startValue, endValue].sort((a, b) => a - b);
    }
  }

  const matches = rawValue.match(/-?\d+(\.\d+)?/g);
  if (matches?.length >= 2) {
    const [startValue, endValue] = matches.slice(0, 2).map(Number);
    if (!Number.isNaN(startValue) && !Number.isNaN(endValue)) {
      return [startValue, endValue].sort((a, b) => a - b);
    }
  }

  return null;
};

export const normalizeIdentifierValue = value => (value === undefined || value === null ? '' : String(value).trim());

export const isDevelopmentMode = () =>
  process.env.REACT_APP_ORION_ENV === 'local' || process.env.REACT_APP_ORION_ENV === 'development';

export const isFirebrandMetadataV2Enabled = () => process.env.REACT_APP_ENABLE_FIREBRAND_METADATA_V2 === 'true';

export const getInputTestProps = testId => ({
  slotProps: {
    input: { 'data-testid': testId },
    htmlInput: { 'data-testid': testId },
  },
});
